export default {
  errorInvalidLinkButton: 'error-invalid-link-button',
}
